import { Component, Inject } from '@angular/core';

import { CMPS_EC_SWITCH_CONTEXT } from '../../model/metadata';
import { SwitchContext } from '../../model/switch-context.model';

@Component({
    selector: 'cmps-event-centre-c-pop-footer',
    templateUrl: './footer.component.html',
    host: {
        class: 'cmps-event-centre-c-pop-footer cmps-cdk-d-block cmps-cdk-w-100pct',
    },
})
export class FooterComponent {
    constructor(
        /** @private */ @Inject(CMPS_EC_SWITCH_CONTEXT)
        readonly _data: SwitchContext,
    ) {}
}
